import { REGEX } from '@/constants/regex';
import { ILottieComponentProps } from '@/types/common';
import { replaceColor } from 'lottie-colorify';
import Lottie from 'lottie-react';
import homeAnimation from './lotties/Home.json';

export const HomeLottie = ({ color = '' }: ILottieComponentProps) => {
  const isValidColor = new RegExp(REGEX.HEX_COLOR).test(color);
  const coloredHomeAnimation = isValidColor
    ? replaceColor([147, 149, 152], color, homeAnimation)
    : homeAnimation;

  return (
    <Lottie
      style={{ height: '40px' }}
      animationData={coloredHomeAnimation}
      loop={false}
    />
  );
};
